import a, { useState as T } from "react";
import { Tab as h } from "./components/Tab/Tab.js";
import { Tablist as I } from "./components/Tablist/Tablist.js";
import { TabPanel as f } from "./components/TabPanel/TabPanel.js";
var N = Object.defineProperty,
  v = Object.getOwnPropertySymbols,
  P = Object.prototype.hasOwnProperty,
  D = Object.prototype.propertyIsEnumerable,
  _ = (n, l, r) => l in n ? N(n, l, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : n[l] = r,
  y = (n, l) => {
    for (var r in l || (l = {})) P.call(l, r) && _(n, r, l[r]);
    if (v) for (var r of v(l)) D.call(l, r) && _(n, r, l[r]);
    return n;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const E = _ref => {
  let {
    isPersistent: n,
    children: l,
    onChange: r
  } = _ref;
  var s, p, c, u;
  const S = e => {
      var o, i;
      return a.isValidElement(e) && e.type === h && ((o = e.props) == null ? void 0 : o.id) && !((i = e.props) != null && i.hidden);
    },
    t = a.Children.toArray(l).filter(S),
    w = (u = (c = (s = t == null ? void 0 : t.find(e => {
      var o;
      return (o = e == null ? void 0 : e.props) == null ? void 0 : o.selected;
    })) == null ? void 0 : s.props.id) != null ? c : (p = t == null ? void 0 : t[0]) == null ? void 0 : p.props.id) != null ? u : "",
    [d, O] = T(w),
    m = e => {
      O(e), r == null || r(e);
    };
  return t != null && t.length ? a.createElement("div", {
    className: "olx-tabs",
    "data-ds-component": "DS-Tabs"
  }, a.createElement(I, {
    selectedTabId: d,
    onSelectTab: m
  }, t.map(e => a.cloneElement(e, {
    selected: e.props.id === d,
    onSelectTab: m
  }))), t.map(e => {
    const {
        id: o
      } = e.props,
      i = o === d,
      b = {
        id: o,
        selected: i
      };
    if (i && !n) return a.createElement(f, y({
      key: e.key
    }, b), e.props.children);
    if (n) return a.createElement(f, y({
      key: e.key
    }, b), e.props.children);
  })) : null;
};
E.displayName = "Tabs";
export { E as Tabs };